import rem from "./rem.js"
import {isPC_} from "./rem.js"
import metaInfoUtils from 'config/metaInfo.config.js';
//固定变量
export const page=1;
export const rows=10;

// function setRem(document) {
// 	let baseSize = 100;//基准大小   1rem为100px
// 	let designWidth=1920;//设计宽度
// 	let docEl = document.documentElement;
// 	let clientWidth = docEl.clientWidth;
// 	if (clientWidth) {
// 		docEl.style.fontSize =baseSize * clientWidth / designWidth + "px";
// 	} else {
// 		return;
// 	}
// }
/**
 * 适配屏幕
 */
export function initRem(document, window) {
	rem.initRem(document, window);
	// if (document.addEventListener) {
	// 	setRem(document);
	// } else {
	//   return;
	// }
	// document.addEventListener("ready",()=>{setRem(document);}, false);
	// window.addEventListener("resize", ()=>{setRem(document);}, false);
}

/**
 * 是否pc端
 */
export function isPC() {
	return isPC_();
}

//===================时间操作===================
/**
 * [时间差]
 * @param {[str]} 需要比较的时间
 */
export function timeDiff_now(str){
	let result="";
	if(str){
		let time = new Date(str).getTime();//日期字符串转时间戳
		if(isAllNum(time)){
			let timestamp=new Date().getTime();//当前时间
			if(timestamp>time){
				let diff=timestamp-time;
				let day=Math.floor(diff/(1000*60*60*24));//天
				let hour=Math.floor((diff-day*24*60*60*1000)/(1000*60*60));//小时
				let minute=Math.floor((diff-day*24*60*60*1000-hour*60*60*1000)/(1000*60));//分
				result=day+"天"+hour+"小时"+minute+"分";
			}
		}
	}
	return result;
}

/**
 * [时间戳转化为字符串 2019-11-11 00:00:00]
 * @param {[num]} 时间戳
 */
export function time_numToStr(num){
	try {
		let d = new Date(num);    //根据时间戳生成的时间对象
		let date = (d.getFullYear()) + "-" +
				(d.getMonth() + 1) + "-" +
				(d.getDate()) + " " +
				(d.getHours()) + ":" +
				(d.getMinutes()) + ":" +
				(d.getSeconds());
		return date;
	} catch (error) {
		console.log("传入参数不为时间戳");
	}
	return "";
}
/**
 * [时间戳转化为字符串 2019-11-11]
 * @param {[num]} 时间戳
 */
export function time_numToStrOnlyDate(num){
	try {
		let d = new Date(num);    //根据时间戳生成的时间对象
		let date = (d.getFullYear()) + "-" +
				((d.getMonth() + 1)<10?'0'+(d.getMonth() + 1):(d.getMonth() + 1)) + "-" +
				((d.getDate())<10?'0'+(d.getDate()  ):(d.getDate() ))
		return date;
	} catch (error) {
		console.log("传入参数不为时间戳");
	}
	return "";
}
/**
 * [获得星期几]
 * @param {[num]} 时间戳
 */
export function time_getDay(num){
	try {
		let d = new Date(num).getDay();    //根据时间戳生成的时间对象
		let date =''
		switch (d) {
			case 0:
			date = "星期日";
			break;
			case 1:
			date = "星期一";
			break;
			case 2:
			date = "星期二";
			break;
			case 3:
			date = "星期三";
			break;
			case 4:
			date = "星期四";
			break;
			case 5:
			date = "星期五";
			break;
			case 6:
			date = "星期六";
			break;
		}
		return date;
	} catch (error) {
		console.log("传入参数不为时间戳");
	}
	return "";
}
/**
 * [计算年龄]
 * @param {[num]} 时间戳
 */
export function  jsGetAge(str){
	try {
		var   r   =   str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
        if(r==null)return   false;
        var   d=   new   Date(r[1],   r[3]-1,   r[4]);
        if   (d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4])
        {
              var   Y   =   new   Date().getFullYear();
              return(Y-r[1]);
        }
        return("输入的日期格式错误！");
	} catch (error) {
		console.log("传入参数不为时间戳");
	}
	return "";
}


//===================时间操作===================

//===================其他===================
/**
 * [是否全为数字]
 * @param {[str]}
 */
export function isAllNum(str){
	if(/^[0-9]+$/.test(str)){//这是用正则表达是检查
		return true;
	}else{
		return false;
	}
}

/**
 * [只能为数字和字符串]
 * @param {[str]}
 */
export function onlyStrAndNum(value){
	if(/^[a-z0-9]*$/g.test(value)){//这是用正则表达是检查
		return true;
	}else{
		return false;
	}
}

/**
 * 去除参数空数据
 * @param {Object} obj [参数对象]
 */
export let filterEmptyData = (obj) => {
    for (let prop in obj) {
        obj[prop] === '' ? delete obj[prop] : obj[prop]
    }
    return obj
}

/*
* 验证手机号是否合格
* true--说明合格
*/
export function isPhone (phoneStr){
	let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
	if (!myreg.test(phoneStr)) {
		return false;
	} else {
		return true;
	}
}

/*
* 验证手机号是否合格
* true--说明合格
*/
export function isPhone2 (phoneStr){
	let myreg = /^[1][0-9]{10}$/;
	if (!myreg.test(phoneStr)) {
		return false;
	} else {
		return true;
	}
}

/*
* 验证身份证号
* true--说明合格
*/
export function isIdcard (idcode){
	let idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
	if (!idcard_patter.test(idcode)) {
		return false;
	} else {
		return true;
	}
}

/*
* 生日转为年龄
* true--说明合格
*/
export function birsdayToAge (birsday) {
	let aDate = new Date();
	let thisYear = aDate.getFullYear();
	let bDate = new Date(birsday);
	let brith = bDate.getFullYear();
	let age = (thisYear - brith);
	return age
}

/*
* 保留两位小数(注意：小数值为0的情况只返回整数部分，如：30.00  30.0001都返回30)
*/
export function numShow (num) {
   try {
		let num_tem=num.toFixed(2);
		let num_tem2=Math.floor(num);
		if(num_tem>num_tem2){
			return num_tem;
		}else{
			return num_tem2;
		}
   } catch (error) {
		return num;
   }
}

/*
* 是否数组
*/
export function isArray (val) {
	if(val&&val instanceof Array){
		return true;
	}else{
		return false;
	}
 }

 /*
* 是否空数组
*/
export function isArrayEmpty (val) {
	if(val&&val instanceof Array&&val.length>0){
		return false;
	}else{
		return true;
	}
 }

  /*
* 是否空对象
*/
export function isObjectEmpty (val) {
	if(val&&val instanceof Object){
		for (let item in val) {
			return false;
		}
		return true;
	}else{
		return true;
	}
 }

 /**
 * [是否不为空：包括：undefined  空格  多个空格]
 * @param {[str]}
 */
export function isNoNullAll(str){
	if(str===0||(str&&String(str).trim())){//这是用正则表达是检查
		return true;
	}else{
		return false;
	}
}

 // 格式化日期，如月、日、时、分、秒保证为2位数
function formatNumber (n) {
    n = n.toString()
    return n[1] ? n : '0' + n;
}

 /**
 * 时间戳转化为时间字符串
 * @param {*} number
 * @param {*} format    'Y-M-D h:m:s'   'Y年M月D日 h:m:s'
 */
export function formatTime (number, format) {
    let time = new Date(number)
    let newArr = []
    let formatArr = ['Y', 'M', 'D', 'h', 'm', 's']
    newArr.push(time.getFullYear())
    newArr.push(formatNumber(time.getMonth() + 1))
    newArr.push(formatNumber(time.getDate()))

    newArr.push(formatNumber(time.getHours()))
    newArr.push(formatNumber(time.getMinutes()))
    newArr.push(formatNumber(time.getSeconds()))

    for (let i in newArr) {
        format = format.replace(formatArr[i], newArr[i])
    }
    return format;
}
//===================其他====================

//将二维数组转换成一维数组
export function arrayConcat(arr) {
	let concatArr = [],
		arrCopy = [...arr];
	let leni = arrCopy.length-1;
	for(let i = leni ;i>=0;i--){
	  if(!this.isArrayEmpty(arrCopy[i])){
		let lenj = arrCopy[i].length-1
		for(let j = lenj ;j>=0;j--){
		  concatArr = concatArr.concat(arrCopy[i][j])
		}
	  }
	}
	return concatArr;
  }

  //数组去重
export function arraySet(arr, key) {
	for (let i = 0; i < arr.length; i++) {
	  for (let j = i + 1; j < arr.length; j++) {
		if (arr[i][key] === arr[j][key]) {
		  arr.splice(j, 1);
		  j = j - 1;
		}
	  }
	}
}

/**
 * 处理结构树数据(两层树)
 * 将数据字段名替换成特定名称
 */
export function resetOrgTree(tree) {
  let data = [];
  if(!this.isArrayEmpty(tree)) {
    tree.forEach(item=>{
      item.label = item.gradeName;
      item.children = item.classList;
      if(!this.isArrayEmpty(item.classList)){
        item.classList.forEach(citem=>{
          citem.label = citem.className;
        })
      }
    })
    data = tree;
  }
  return data
}


/*
 *筛选配置文件中对应的下拉框选项
 */
export function filterConfig(bindValue,config) {
  let result = [],
      filterResult = [];
  if(bindValue){
    if(config.select && !isArrayEmpty(config.select)){
      filterResult = config.select.filter(item=>{
        return item.prop === bindValue;
      })
      if(!isArrayEmpty(filterResult)){
        result = filterEmptyOption(filterResult[0].options) || [];
      }
    }
  }
  return result;
}

/*
 *筛选下拉框选项中的'全部'选项
 */
export function filterEmptyOption(options) {
  let result = [];
  if(!isArrayEmpty(options)){
    result = options.filter(item=>{
      return item.label !== '全部' && item.value !== '';
    })
  }
  return result;
}

/**
 * 四舍五入保留2位小数（若第二位小数为0，则保留一位小数） 
 * @param {*} num 
 */
export function keepTwoDecimal(num) {
	var result = parseFloat(num);
	if (isNaN(result)) {
		return num;
	}
	result = Math.round(num * 100) / 100;
	return result;
}


/**
 * 活动创建时间段判断
 */
export function isUseOver(time,serviceTime){//当前时间大于time
	if(serviceTime&&time){
		try {
			time=time.trim(); 
			if(time.length==10){
				time=time+" 00";
			}else if(time.length>13){
				time=time.substring(0,13);
			}
			// console.log(new Date(time+":00:00").getTime()<serviceTime)
			// console.log(new Date(time+":00:00").getTime(),serviceTime)
			if(new Date(time+":00:00").getTime()<serviceTime){
				return true;
			}
		} catch (error) {
			return false;
		}
	}else{
		return false;
	}
}

/**
 * 过滤活动类型
 */
export function fileTypes(val){//   
	let str = '';
	val.level==0 ? str="区级 " : str="校级 ";
	switch (Number(val.workType)) {
		case 0:
			str += '- 微课';
			break;  
		case 5:
				str += '- 课件';
				break;  
		case 6:
				str += '- 教案';
				break;  
		case 13:
				str += '- 课堂实录';
				break;  
		case 14:
				str += '- 案例资源';
				break;  
	}
	switch (val.attend) {
		case '1':
				str += ' - 教职工 - ';
				break;  
		case '2':
				str += ' - 学生 - ';
				break;  
		case '1,2':
			str += ' - (教职工、学生) - ';
			break;  
	}
	switch (Number(val.section)) {
		case 1:
			str += '小学组';
			break;
		case 2:
			str += "初中组";
			break;
		case 3:
			str += "高中组";
			break;
		case 4:
			str += "幼儿组";
			break;
	}
	return str;
}


/*
 *拼接导航地址栏传参
 */
export function concatParams(obj) {
	let str = '';
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			if(key=='activityInfo'){
				str += key+'='+JSON.stringify(obj['activityInfo']);
			}else{
				str += key+'='+obj[key]+'&';
			}
		}
	}
	str=str.replace(/[%]/g,"%25");
	return str;
}


/*
 * 富文本px转rem
 */
export function pxToRem(content) {
	if (this.isNoNullAll(content)) {
		// 替换富文本为rem
		content = content.replace(/(\d+)px/g, function(s, t) {
			s = s.replace('px', '');
			let value = parseInt(s) * 0.01; // 100px = 1rem
			return value + "rem";
		});
	}
	return content;
}

/**
 * 是否不在可视区域
 * @param {*} el 
 * @returns 
 */
export function isElementNotInViewport(el) {
	if (el) {
		let rect = el.getBoundingClientRect();
		return (
			rect.top >
				(window.innerHeight || document.documentElement.clientHeight) ||
			rect.bottom < 0
		);
	}
}

/**
 * 跳转新闻/资讯详情
 */
export function goDetailPage(router,contentid){
	let tem=window.setTimeout(()=>{
		// router.push({path:'/news/detail',query:{id:contentid},params:{detailId:detailId}});
		router.push({path:'/news/detail/'+contentid+'.html'});
		clearTimeout(tem);
	},200);
}

/**
 * 跳转新闻/资讯详情
 */
export function goDetailPagePath(contentid){
    return "/news/detail/"+contentid+".html";
}